import { SW_VERSION_STORAGE_KEY, SW_MEMBER_ID_STORAGE_KEY } from "../constants/index.js";
function _register(worker, config) {
  if (config.env === "production" && "serviceWorker" in navigator) {
    const publicUrl = new URL(config.publicUrl, worker.location.href);
    if (publicUrl.origin !== worker.location.origin) {
      return;
    }
    worker.addEventListener("load", () => {
      const swUrl = `${config.publicUrl}/${config.fileName}`;
      const isLocalhost = Boolean(
        worker.location.hostname === "localhost" || // [::1] is the IPv6 localhost address.
        worker.location.hostname === "[::1]" || // 127.0.0.0/8 are considered localhost for IPv4.
        worker.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
      );
      if (isLocalhost) {
        checkValidServiceWorker(worker, swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log(
            "This web app is being served cache-first by a service worker. To learn more, visit https://cra.link/PWA"
          );
        });
      } else {
        registerValidSW(worker, swUrl, config);
      }
    });
  }
}
async function subscribe(worker, serviceWorkerReg, config) {
  if (!config.notificationURI) return;
  if (!serviceWorkerReg.pushManager) {
    console.log("Push notifications are not supported in this browser");
    return;
  }
  let version = void 0;
  try {
    version = await config.getVersion();
    if (!version) throw new Error("Invalid version");
    const subscribeNotifAtVersion = sessionStorage.getItem(config.storageKeyVersion ?? "");
    if (version && subscribeNotifAtVersion === version) {
      return;
    }
  } catch (error) {
    console.log("Error on fetching version:", error);
  }
  try {
    const notificationInfoResponse = await fetch(config.notificationURI + config.notificationInfoEndpoint, {
      method: "GET"
    });
    const {
      result: {
        subscribeEndpoint,
        vapidKey
        // skip
      }
    } = await notificationInfoResponse.json();
    const params = new URLSearchParams(worker.location.search);
    const notificationTestValues = params.get(config.notificationTestParam ?? "");
    if (!!subscribeEndpoint) {
      let subscription = await serviceWorkerReg.pushManager.getSubscription();
      if (!subscription && !!vapidKey) {
        let unsub = false;
        try {
          subscription = await serviceWorkerReg.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: vapidKey
          });
        } catch (error) {
          console.log(error);
          if ("message" in error) {
            if (error.message.startsWith("Registration failed - A subscription with a different applicationServerKey")) {
              unsub = true;
            }
          }
        }
        if (unsub && !!subscription) {
          await subscription.unsubscribe();
        }
      }
      if (!!subscription) {
        const domain = window.location.hostname ?? "";
        const memberId = sessionStorage.getItem(config.storageKeyMemberId ?? SW_MEMBER_ID_STORAGE_KEY) ?? void 0;
        try {
          await fetch(config.notificationURI + subscribeEndpoint, {
            method: "POST",
            body: JSON.stringify({
              subscription,
              client: notificationTestValues ?? domain,
              accountId: config.accountId,
              memberId
            }),
            headers: {
              "Content-Type": "application/json"
            }
          });
          sessionStorage.setItem(config.storageKeyVersion ?? SW_VERSION_STORAGE_KEY, version ?? "");
        } catch (error) {
          console.log("Subscribe Error", error);
        }
      }
    }
  } catch (error) {
    console.log("Fetching notification info failed", error);
  }
}
function registerValidSW(worker, swUrl, config) {
  navigator.serviceWorker.register(swUrl).then((registration) => {
    registration.onupdatefound = () => {
      const newSW = registration.installing;
      if (newSW == null) {
        return;
      }
      newSW.onstatechange = () => {
        if (newSW.state === "installed") {
          if (navigator.serviceWorker.controller) {
            console.log(
              "New content is available and will be used when all tabs for this page are closed. See https://cra.link/PWA."
            );
            if (config && config.onUpdate) {
              config.onUpdate(registration);
            }
          } else {
            console.log("Content is cached for offline use.");
            if (config && config.onSuccess) {
              config.onSuccess(registration);
            }
          }
        }
      };
    };
    return navigator.serviceWorker.ready;
  }).then(async (registration) => {
    await subscribe(worker, registration, config);
  }).catch((error) => {
    console.error("Error during service worker registration:", error);
  });
}
function checkValidServiceWorker(worker, swUrl, config) {
  fetch(swUrl, {
    headers: { "Service-Worker": "script" }
  }).then((response) => {
    const contentType = response.headers.get("content-type");
    if (response.status === 404 || contentType != null && contentType.indexOf("javascript") === -1) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.unregister().then(() => {
          sessionStorage.clear();
          if ("reload" in worker.location) worker.location.reload();
        });
      });
    } else {
      registerValidSW(worker, swUrl, config);
    }
  }).catch(() => {
    console.log("No internet connection found. App is running in offline mode.");
  });
}
function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister().then(() => sessionStorage.clear());
    }).catch((error) => {
      console.error(error.message);
    });
  }
}
const createSWRegistration = (worker, configs) => {
  configs.notificationInfoEndpoint = configs.notificationInfoEndpoint ?? "/notification/info";
  configs.storageKeyVersion = configs.storageKeyVersion ?? SW_VERSION_STORAGE_KEY;
  configs.storageKeyMemberId = configs.storageKeyMemberId ?? SW_MEMBER_ID_STORAGE_KEY;
  configs.fileName = configs.fileName ?? "service-worker.js";
  return {
    register: () => _register(worker, configs),
    unregister
  };
};
export {
  createSWRegistration
};
